






















































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Select2, Radio } from '@/components/form'
import { DatePicker } from '@/components/general'
import HeaderFormSelectArea from '../HeaderFormSelectArea.vue'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

// models
import { LunchControlForm } from '@/models/dailyControl'
import { IEmployee, RateLunch } from '@/models/config'
import { PropOptionSelect } from '@/models'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// services
import { LunchControlsService } from '@/services/dailyControl'

@Component({
    name: 'FormCreateEditLunchControl',
    components: {
        Input,
        Select2,
        DatePicker,
        HeaderFormSelectArea,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormCreateEditLunchControl extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) lunchControl!: LunchControlForm
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ type: Array, default: () => [] }) employees!: IEmployee[]
    @Prop({ type: Array, default: () => [] }) rateLunchs!: RateLunch[]

    form: LunchControlForm = {
        date: '',
        employee_id: null,
        lunch_rate_id: null
    }

    dateAvailable: string[] = []
    typeForm = 1
    optionsTypeForm = [
        {
            text: 'POR EMPLEADO',
            value: 1
        },
        {
            text: 'POR ÁREA',
            value: 2
        }
    ]

    areaSelectedId: number|null = null
    subAreaSelectedId: number|null = null
    employeesSelected: number[] = []

    get employeeSelected (): IEmployee | null {
        if (this.form.employee_id && this.employeesOp.find(employee => employee.value === this.form.employee_id)) {
            const employee = this.employees.find(e => e.id === this.form.employee_id)
            if (employee) {
                return employee
            }
        }
        return null
    }

    get ratesOp (): PropOptionSelect[] {
        return this.rateLunchs.map(rate => {
            return {
                value: rate.id ?? 0,
                text: `${rate.name} - S/. ${rate.price}`
            }
        })
    }

    get employeesOp (): PropOptionSelect[] {
        return this.employees.filter(employee => (employee.assignment.lunch && this.actionForm === 'save' && this.typeForm === 2) ? Number(employee.assignment.sub_area_id) === Number(this.subAreaSelectedId) : employee.assignment.lunch).map(employee => {
            return {
                value: employee.id ?? null,
                text: getFullNameFormat(employee)
            }
        })
    }

    setAllEmployeesBySubArea (subAreaSelectedId: number) {
        this.subAreaSelectedId = subAreaSelectedId
        if (subAreaSelectedId) {
            this.employeesSelected = this.employees.filter(employee => Number(employee.assignment.sub_area_id) === Number(subAreaSelectedId) && employee.assignment.lunch).map(employee => employee.id)
        } else {
            this.employeesSelected = []
        }
    }

    created () {
        if (this.idEdit) {
            this.form = this.lunchControl
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                date: { required },
                employee_id: {
                    required: requiredIf(() => this.actionForm !== 'save' || this.typeForm === 1)
                },
                lunch_rate_id: { required }
            },
            areaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            subAreaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            employeesSelected: { required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2), minLength: 1 }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await LunchControlsService.update(this.idEdit, this.form)
                } else {
                    if (this.typeForm === 2) {
                        for (let i = 0; i < this.employeesSelected.length; i++) {
                            this.form.employee_id = this.employeesSelected[i]
                            const result = await LunchControlsService.validateLunch(null, this.form)
                            if (!result.success) {
                                const employee = this.employeesOp.find(employee => Number(employee.value) === Number(this.form.employee_id))
                                let message = ''
                                if (employee) {
                                    message = `El empleado: ${employee.text}, ${result.msg}`
                                }
                                alerts.error(message)
                                loading('hide')
                                return
                            }
                        }
                        for (let i = 0; i < this.employeesSelected.length; i++) {
                            this.form.employee_id = this.employeesSelected[i]
                            await LunchControlsService.create(this.form)
                        }
                    } else {
                        await LunchControlsService.create(this.form)
                    }
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    date: '',
                    employee_id: null,
                    lunch_rate_id: null
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error(String(e))
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    setListDateAvailable () {
        if (this.form.employee_id && this.employeeSelected) {
            const listDate = getListDateAvailable(this.employeeSelected.cessation)
            this.dateAvailable = listDate
        }
    }
}
